export default __webpack_public_path__ + "static/media/blackFront3.fd45c8eb.png";